import React from 'react';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center py-20 px-4 overflow-hidden" data-id="element-22">
      {/* FONDO: Imagen de portada desenfocada */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/eN7fRDDkwak2ta26ndZn55/ChatGPT_Image_27_dic_2025,_04_18_37.png)',
      filter: 'blur(60px) brightness(0.4)',
      transform: 'scale(1.2)'
    }} data-id="element-23" />
      <div className="absolute inset-0 bg-black/60" data-id="element-24" />

      <div className="max-w-6xl mx-auto w-full relative z-10" data-id="element-25">
        {/* Layout para desktop: grid de 2 columnas */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-12 items-center" data-id="element-26">
          <div className="text-left space-y-8" data-id="element-27">
            <div className="inline-block bg-green-900/30 border border-green-500/30 rounded-full px-4 py-1" data-id="element-28">
              <span className="text-green-400 font-bold text-sm tracking-wider uppercase" data-id="element-29">
                Guía Práctica 2025
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl font-black text-white leading-tight" data-id="element-30">
              CÓMO EMPEZAR A <br data-id="element-31" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-600" data-id="element-32">
                GANAR DINERO
              </span>{' '}
              <br data-id="element-33" />
              EXTRA YA
            </h1>

            <p className="text-xl md:text-2xl text-slate-300 leading-relaxed" data-id="element-34">
              Cómo empezar desde cero y usar la{' '}
              <span className="text-green-400 font-bold" data-id="element-35">
                inteligencia artificial
              </span>{' '}
              para generar ingresos extra de forma simple y realista.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-36">
              <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-500 text-white text-lg font-bold py-4 px-8 rounded-lg shadow-lg shadow-green-900/20 transition-all transform hover:scale-105" data-id="element-37">
                QUIERO EMPEZAR AHORA
              </button>
              <button onClick={() => document.getElementById('sales-letter')?.scrollIntoView({
              behavior: 'smooth'
            })} className="bg-slate-800 hover:bg-slate-700 text-white text-lg font-medium py-4 px-8 rounded-lg border border-slate-700 transition-colors flex items-center justify-center gap-2" data-id="element-38">
                Leer más <ArrowDown className="w-4 h-4" data-id="element-39" />
              </button>
            </div>

            <div className="flex items-center gap-4 text-sm text-slate-400 pt-4" data-id="element-40">
              <div className="flex -space-x-2" data-id="element-41">
                <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="User" className="w-8 h-8 rounded-full border-2 border-slate-900" data-id="element-42" />
                <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="User" className="w-8 h-8 rounded-full border-2 border-slate-900" data-id="element-43" />
                <img src="https://randomuser.me/api/portraits/men/46.jpg" alt="User" className="w-8 h-8 rounded-full border-2 border-slate-900" data-id="element-44" />
                <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="User" className="w-8 h-8 rounded-full border-2 border-slate-900" data-id="element-45" />
              </div>
              <p data-id="element-46">+1,200 personas ya están aplicando este método</p>
            </div>
          </div>

          <div className="relative mx-auto max-w-md lg:max-w-full" data-id="element-47">
            <div className="absolute inset-0 bg-green-500/20 blur-[100px] rounded-full" data-id="element-48" />
            <img src="https://cdn.magicpatterns.com/uploads/eN7fRDDkwak2ta26ndZn55/ChatGPT_Image_27_dic_2025,_04_18_37.png" alt="Cómo empezar a ganar dinero extra ya - Ebook Cover" className="relative z-10 w-full drop-shadow-2xl transform hover:scale-105 transition-transform duration-700" data-id="element-49" />
          </div>
        </div>

        {/* Layout para móvil: orden específico */}
        <div className="lg:hidden text-center space-y-6" data-id="element-50">
          <div className="inline-block bg-green-900/30 border border-green-500/30 rounded-full px-4 py-1" data-id="element-51">
            <span className="text-green-400 font-bold text-sm tracking-wider uppercase" data-id="element-52">
              Guía Práctica 2025
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl font-black text-white leading-tight px-2" data-id="element-53">
            CÓMO EMPEZAR A <br data-id="element-54" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-600" data-id="element-55">
              GANAR DINERO
            </span>{' '}
            <br data-id="element-56" />
            EXTRA YA
          </h1>

          {/* PORTADA - Después del título, antes del subtítulo */}
          <div className="relative mx-auto max-w-xs py-4" data-id="element-57">
            <div className="absolute inset-0 bg-green-500/20 blur-[80px] rounded-full" data-id="element-58" />
            <img src="https://cdn.magicpatterns.com/uploads/eN7fRDDkwak2ta26ndZn55/ChatGPT_Image_27_dic_2025,_04_18_37.png" alt="Cómo empezar a ganar dinero extra ya - Ebook Cover" className="relative z-10 w-full drop-shadow-2xl" data-id="element-59" />
          </div>

          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed px-4" data-id="element-60">
            Cómo empezar desde cero y usar la{' '}
            <span className="text-green-400 font-bold" data-id="element-61">
              inteligencia artificial
            </span>{' '}
            para generar ingresos extra de forma simple y realista.
          </p>

          <div className="flex flex-col gap-4 pt-4 px-4" data-id="element-62">
            <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-500 text-white text-lg font-bold py-4 px-8 rounded-lg shadow-lg shadow-green-900/20 transition-all transform hover:scale-105" data-id="element-63">
              QUIERO EMPEZAR AHORA
            </button>
            <button onClick={() => document.getElementById('sales-letter')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-slate-800 hover:bg-slate-700 text-white text-lg font-medium py-4 px-8 rounded-lg border border-slate-700 transition-colors flex items-center justify-center gap-2" data-id="element-64">
              Leer más <ArrowDown className="w-4 h-4" data-id="element-65" />
            </button>
          </div>

          <div className="flex items-center justify-center gap-4 text-sm text-slate-400 pt-4" data-id="element-66">
            <div className="flex -space-x-2" data-id="element-67">
              <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="User" className="w-8 h-8 rounded-full border-2 border-slate-900" data-id="element-68" />
              <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="User" className="w-8 h-8 rounded-full border-2 border-slate-900" data-id="element-69" />
              <img src="https://randomuser.me/api/portraits/men/46.jpg" alt="User" className="w-8 h-8 rounded-full border-2 border-slate-900" data-id="element-70" />
              <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="User" className="w-8 h-8 rounded-full border-2 border-slate-900" data-id="element-71" />
            </div>
            <p data-id="element-72">+1,200 personas ya están aplicando este método</p>
          </div>
        </div>
      </div>
    </section>;
}